import { Tooltip } from "@mui/material"; 
import { AutoGraph } from "@mui/icons-material";
import { yellow } from "@mui/material/colors";
import './BiddingRuleTooltip.scss';

const bidStatusIcon = {
  "running": <AutoGraph fontSize="14px" sx={{ color: "green" }} />,
  "warning": <AutoGraph fontSize="14px" sx={{ color: yellow[700] }} />,
  "paused": <AutoGraph fontSize="14px" sx={{ color: "red" }} />
};

const BiddingRuleTooltip = ({ bid }) => {
  return (
    <Tooltip
      title={
        <div className="bid-tooltip">
          <div className="bid-tooltip-header">
            <span className="bid-tooltip-label">Bidding Rule</span>
            {bidStatusIcon[bid?.bidding_rule_icon]}
          </div>
          {Array.isArray(bid?.bidding_rule_tooltip) &&
          bid.bidding_rule_tooltip.length > 0 ? (
            bid.bidding_rule_tooltip.map((msg, i) => (
              <div key={i} className="bid-tooltip-message">
                {msg}
              </div>
            ))
          ) : (
            <div className="bid-tooltip-message">
              No bidding rule info available
            </div>
          )}
        </div>
      }
    >
      {bid?.has_bidding_rule === true && bidStatusIcon[bid?.bidding_rule_icon]}
    </Tooltip>
  );
};

export default BiddingRuleTooltip;
